// 优惠券路由 (需求 7142262899; 菜单 link 与 sudu_privilege 行对应)
export default {
    path: 'coupon',
    component: () => import('@/components/RouterView'),
    redirect: '/manage/coupon/list',
    meta: {title: '优惠券'},
    children: [{
        path: 'list',
        name: 'couponList',
        component: () => import('@/views/manage/coupon/list'),
        // 页面自带标题栏, 关闭布局层标题避免顶部出现两条「优惠券列表」
        meta: {title: '优惠券列表', showTitle: false},
    }, {
        path: 'redeem',
        name: 'couponRedeem',
        component: () => import('@/views/manage/coupon/redeem'),
        meta: {title: '兑换码明细', showTitle: false},
    }]
}
